<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" title="Contents">
<p class="fmtitle"><a id="page_vii"><b>Contents</b></a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/07_Introduction">Introduction</a></p>
<p class="toc"><a href="#/xhtml/08_Chapter01">1.  Enslaved Men and Work</a></p>
<p class="toc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample">2.  Enslaved Men and Leisure</span></p>
<p class="toc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">3.  Beyond the Plantation</span></p>
<p class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">4.  Friendship, Resistance, and Runaways</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">5.  Enslaved Men, the Grapevine Telegraph, and the Underground Railroad</span></p>
<p class="toc"><span href="#/xhtml/13_Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/14_Acknowledgement" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/15_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/16_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/xhtml/17_Index01" title="Link target outside of Sample">Index</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?d3508e76